import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import QRCode from 'react-qr-code';
import AppGeneralPopup from '@common/app_general_popup';
import { appGeneralPopupTheme } from '@common/config/const';
import { downloadAppLink } from '@common/config/utils';
import { SvgIcon } from '@common/sprites';
import classes from './classes.module.scss';

const renderDesktopContent = (downloadLink: string) => (downloadLink ? (
  <div className={ classes.desktopContentContainer }>
    <div className={ classes.qrCodeContainer }>
      <QRCode
        size={ 170 }
        bgColor="white"
        fgColor="black"
        style={ { position: 'absolute', width: '170px' } }
        value={ downloadLink }
        viewBox="0 0 170 170"
        level="L"
      />
    </div>
    <div className={ classes.qrCodeTextContainer }>
      <SvgIcon className={ classes.qrCodeIcon } id="qrcode_icon" size={ [13, 22] } />
      <span className={ classes.qrCodeText }>
        <Trans
          i18nKey="app_download_app_popup.scan_to_download"
          components={ {
            bold:<b className={ classes.boldText } />,
            normal:<span className={ classes.normalText } />
          } }
        />
      </span>
    </div>
  </div>
) : null);

function LoyaltyDownloadAppPopup({
  url,
  visible = true,
  onClose
}: {
  url: string;
  visible?: boolean;
  onClose?: () => void;
}) {
  const { t } = useTranslation();
  const popupDownloadAppLink = downloadAppLink({ afChanel: 'loyalty_program_download_popup', url });

  const onClosePoppup = () => {
    if (onClose) {
      onClose();
    }
  };

  const onDownloadBtnClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const renderDownloadBtn = (link: string) => (
    <a
      href={ link }
      onClick={ onDownloadBtnClick }
      target="_blank"
      rel="noopener noreferrer"
      className={ classes.downloadAppPopupLink }
    >
      { t('loyalty_download_app_popup.download_button') }
    </a>
  );

  const renderPoppup = () => (
    <AppGeneralPopup
      visible={ visible }
      theme={ appGeneralPopupTheme.CENTERED }
      customTopHeader={ null }
      backArrowAction={ null }
      closeButtonAction={ null }
      rightCustomItem={ null }
      backCustomAction={ null }
      title={ null }
      closable={ onClosePoppup }
      logoImg={ null }
    >
      <div className={ classes.downloadAppPopupContentContainer }>
        <div className={ classes.starIconContainer }>
          <SvgIcon id="loyalty_popup_icon" size={ 73 } className={ classes.starIcon } />
        </div>
        <button type="button" className={ classes.downloadAppPopupCloseBtn } onClick={ onClosePoppup }>
          <SvgIcon id="close_icon" className={ classes.downloadAppPopupCloseImg } />
        </button>
        <div className={ classes.titleSection }>
          <div className={ classes.downloadAppPopupTitle }>
            { t('loyalty_download_app_popup.title') }
          </div>
        </div>
        <div className={ classes.descriptionSection }>
          <div className={ classes.downloadAppPopupText }>
            <Trans
              i18nKey={ t('loyalty_download_app_popup.description') }
              components={ {
                bold:<b className={ classes.boldText } />,
                normal:<span className={ classes.normalText } />,
                purpleText:<span className={ classes.purpleText } />
              } }
              values={ { minutes: 0 } }
            />
          </div>
        </div>
        { isMobile ? renderDownloadBtn(popupDownloadAppLink) : renderDesktopContent(popupDownloadAppLink) }
      </div>
    </AppGeneralPopup>
  );

  return renderPoppup();
}

export default LoyaltyDownloadAppPopup;
